module.exports = __webpack_public_path__ + "img/settings-hover.fa7889dc.svg";